module.exports = __webpack_public_path__ + "img/bold-prev-arrow.7c2cceea.svg";